import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  loading = false;
  wellcome = 'Ingresa tu correo institucional y tu contraseña.<br><br>';

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    rememberme: new FormControl(false)
  });
  constructor(
    private router: Router,
    private apiService: ApiService,
    private readonly snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
  }

  async login() {
    this.loading = true;
    let token = await this.apiService.login(this.loginForm.value);
    this.loading = false;
    if (token) {

      if (this.apiService.user.type == 'owner') {
        this.router.navigate(['/']);
      } else {
        this.snackBar.open('Sin autorización.', 'Error', { duration: 4000 });
        this.apiService.logout();
      }
    }
  }

}
